import type { App } from "vue";
import type { AxiosResponse } from "axios";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/services/JwtService";
import { syncService } from "./sync.service";
import { offlineApiService } from "./offline-api.service";
// import { User } from "./auth";

/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
  /**
   * @description property to share vue instance
   */
  public static vueInstance: App;

  /**
   * @description initialize vue axios
   */
  public static init(app: App<Element>) {
    ApiService.vueInstance = app;
    ApiService.vueInstance.use(VueAxios, axios);
    // const httpsAgent = new https.Agent({
    //   rejectUnauthorized: false,
    // });
    //  ApiService.vueInstance.axios.defaults.httpsAgent = httpsAgent;
    //ApiService.vueInstance.axios.defaults.baseURL ='http://localhost:3002/api';
    //ApiService.vueInstance.axios.defaults["updateUrl"] ='http://localhost:3002/';
    ApiService.vueInstance.axios.defaults.baseURL ='https://api.esogema.bj/api';
    ApiService.vueInstance.axios.defaults["updateUrl"] ='https://api.esogema.bj/';


    ApiService.vueInstance.axios.defaults.headers.common["Accept"] ="application/json";
    ApiService.vueInstance.axios.defaults.headers.common["Content-Type"] ="application/json";
    ApiService.vueInstance.use(VueAxios, axios);
  }

  /**
   * @description set the default HTTP request headers
   */
  public static setHeader(): void {
    ApiService.vueInstance.axios.defaults.headers.common["Authorization"] = `bearer ${JwtService.getToken()}`;
    ApiService.vueInstance.axios.defaults.headers.common["Accept"] ="application/json";
  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static query(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.get(resource, params);
  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param slug: string
   * @returns Promise<AxiosResponse>
   */
  public static async get(resource: string, slug = "" as string): Promise<AxiosResponse> {
    // Si en mode offline, utiliser le service offline
    if (syncService.isOffline()) {
      const endpoint = slug ? `${resource}/${slug}` : resource;
      const result = await offlineApiService.get(endpoint, slug);
      return {
        data: result,
        status: result.success ? 200 : 404,
        statusText: result.success ? 'OK' : 'Not Found',
        headers: {},
        config: {} as any
      } as AxiosResponse;
    }
    return ApiService.vueInstance.axios.get(`${resource}/${slug}`);
  }

  /**
   * @description set the POST HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static async post(resource: string, params: any): Promise<AxiosResponse> {
    // Si en mode offline, utiliser le service offline
    if (syncService.isOffline()) {
      const result = await offlineApiService.post(resource, params);
      return {
        data: result,
        status: result.success ? 200 : 400,
        statusText: result.success ? 'OK' : 'Bad Request',
        headers: {},
        config: {} as any
      } as AxiosResponse;
    }
    return ApiService.vueInstance.axios.post(`${resource}`, params);
  }

  /**
   * @description send the UPDATE HTTP request
   * @param resource: string
   * @param slug: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static update(resource: string,slug: string,params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}/${slug}`, params);
  }

  /**
   * @description Send the PUT HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static put(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}`, params);
  }

  /**
   * @description Send the DELETE HTTP request
   * @param resource: string
   * @returns Promise<AxiosResponse>
   */
  public static delete(resource: string): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.delete(resource);
  }
}

export default ApiService;
